import { Outlet, useNavigate } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { Navbar } from "./Navbar";
import { useEffect, useRef, useState } from "react";
import { mainLayoutService } from "../../services/mainLayout.service";
import { TransactionUpdateReadRequest } from "../../models/Request/transactionUpdateReadRequest";
import { TransactionUpdateStatusList } from "../../models/Response/transactionUpdateStatusResponse";
import { TransactionUpdateModal } from "../ui/modals/TransactionUpdateModal";
import { useLanguage } from "../../config/localization/LanguageProvider";
import { formatDateTime } from "../../utils/dateTimeHelper";
import { useRealTimeStore } from "../../store/signalrRealTime.store";
import { DeviceType } from "../../models/constants/deviceType";
import userDeviceStore from "../../store/device.store";
import { localStorageService } from "../../services";

export function MainLayout() {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const scrollRef = useRef<HTMLDivElement | null>(null);

  const transactionQueue = useRealTimeStore((state) => state.transactionQueue);
  const addTransactionUpdate = useRealTimeStore(
    (state) => state.addTransactionUpdate,
  );
  const removeFirstTransaction = useRealTimeStore(
    (state) => state.removeFirstTransaction,
  );
  const [currentTransaction, setCurrentTransaction] =
    useState<TransactionUpdateStatusList | null>(null);

  const deviceType = userDeviceStore((state) => state.deviceType);

  useEffect(() => {
    const checkAuth = () => {
      const isLoggedIn = localStorageService.getItem("isUserLoggedIn") === true;
      setIsAuthenticated(isLoggedIn);
      if (isLoggedIn) {
        fetchInitialTransactionUpdates();
      }
    };

    checkAuth();

    const handleAuthChange = () => checkAuth();
    window.addEventListener("authChange", handleAuthChange);

    return () => window.removeEventListener("authChange", handleAuthChange);
  }, [isAuthenticated]);
  const fetchInitialTransactionUpdates = async () => {
    const response = await mainLayoutService.fetchTransactionUpdate();

    if (
      response?.isSuccess &&
      response.data &&
      response.data?.details?.length > 0
    ) {
      response.data.details.forEach((item: any) => {
        addTransactionUpdate(item);
      });
    }
  };

  useEffect(() => {
    if (currentTransaction) return;
    if (transactionQueue.length === 0) return;
    // Show first item
    setCurrentTransaction(transactionQueue[0]);
  }, [transactionQueue, currentTransaction]);

  const handleCloseModal = async () => {
    if (!currentTransaction) return;

    const payload: TransactionUpdateReadRequest = {
      transactionrequestupdateid: currentTransaction.id,
      isdepositupdate: currentTransaction.isdepositupdate,
    };

    await mainLayoutService.markTransactionAsRead(payload);
    removeFirstTransaction();
    setCurrentTransaction(null);
  };

  return (
    <div>
      <div className={`w-full lg:max-w-full lg:mx-auto ${deviceType === DeviceType.Mobile ? "pb-20" : "pb-0"}`}>
        <div className="h-screen bg-black text-white flex flex-col">
          <div
            id="main-container"
            className="flex-1 overflow-x-hidden scrollbar-hide relative"
          >
            <div className="sticky top-0 z-50">
              <Header
                deviceType={deviceType}
                isAuthenticated={isAuthenticated}
                onLoginClick={() => navigate("/login")}
                onJoinNowClick={() => navigate("/signup")}
              />
            </div>

            <main className="mt-3 lg:max-w-[90%] mx-auto" ref={scrollRef}>
              <div id="main-content">
                <Outlet />
                <Footer />
              </div>
            </main>
          </div>
        </div>
      </div>

      <div className="lg:hidden">
        <Navbar isAuthenticated={isAuthenticated} />
      </div>
      {currentTransaction && (
        <TransactionUpdateModal
          isOpen={currentTransaction !== null}
          onClose={handleCloseModal}
          dateTime={formatDateTime(currentTransaction.created, true)}
          message={
            language === "en-US"
              ? currentTransaction.remarkstemplatecontent
              : currentTransaction.remarkshindicontent
          }
        />
      )}
    </div>
  );
}
